<template>
  <div class="sentence-dropdown-list">
    <div v-if="isStandard">
      <div v-if="sentence.sentenceList.empty" class="add-variant">
        <div class="dropdown-item" @click="$emit('on-add-variant')">{{ $t("sentence.add-variant") }}</div>
      </div>
      <div class="dropdown-item" @click="$emit('add-scenario-above')">{{ $t("sentence.add-above") }}</div>
      <div class="dropdown-item" @click="$emit('add-scenario-below')">{{ $t("sentence.add-below") }}</div>
    </div>

    <div v-if="isTable">
      <div class="dropdown-item" @click="$emit('add-table-below')">{{ $t("sentence.add-table") }}</div>
    </div>
    <div v-if="isTableHeader || isTableRow">
      <div class="dropdown-item" @click="$emit('add-row-below')">{{ $t("sentence.add-row-scenario") }}</div>
    </div>
    <div v-if="isTableCell">
      <div class="dropdown-item" @click="$emit('add-cell-below')">{{ $t("sentence.add-cell-scenario") }}</div>
    </div>
    <div v-if="isList">
      <div class="dropdown-item" @click="$emit('add-list-below')">{{ $t("sentence.add-list") }}</div>
    </div>
    <div v-if="isListItem">
      <div class="dropdown-item" @click="$emit('add-list-item-below')">{{ $t("sentence.add-list-item") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sentence: Object
  },
  computed: {
    type() {
      return this.sentence.sentenceType;
    },
    isStandard() {
      return ["Sentence", "Linebreak", "Sectionbreak", "NewParagraph", null, undefined].includes(this.type);
    },
    isTable() {
      return this.type === "Table";
    },
    isTableHeader() {
      return this.type === "TableHeaderRow";
    },
    isTableRow() {
      return this.type === "TableRow";
    },
    isTableCell() {
      return ["TableCell", "TableHeaderCell"].includes(this.type);
    },
    isList() {
      return ["UnorderedList", "OrderedList"].includes(this.type);
    },
    isListItem() {
      return this.type === "ListItem";
    }
  }
};
</script>

<style lang="less">
.add-variant {
  padding-bottom: 4px;
  margin-bottom: 4px;
  border-bottom: 1px solid var(--text-grey-primary);
}
</style>
